/**!
 * Created by Leonardo Cheslacki on 05/06/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import PageController from './PageController';

import {HelpersIcon} from './../helpers';

import config from '../../../../config';

const {default: {init: {frame}, gallery, button}} = config;

import WithType from './../helpers/WithType';

let _this = {};

/**
 * REVIEW helpersIcon in all fla for color.
 */
class PageCurrent extends PageController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {};

        this.$helpersIcon = HelpersIcon(this)({current_name: 'page'});

        _this = this;
    };

    $functions = {
        /**
         *
         * @param event
         */
        handle: function (event) {

        }
    };

    /**
     * Not usage direct.
     * @param execute
     */
    defaultInit = (execute = null) => {
        const {current_name} = this.props;

        this.main.$current_name = current_name;

        this.gotoAndStopFrame(this.get(), frame);

        this.pageIn();

        this.main.emit('dynamic_frame', {frame: 1});

        this.$helpersIcon.setIcon(this.get(), button.color_icon);

        this.$helpersIcon.setIcon(this.getFrame(), button.color_icon);

        (typeof (execute) === 'function') && execute();

        /**
         * Preloader
         */
        this.main.emit('process_end', {}, current_name);
    };

    /**
     * Not usage direct.
     * @param execute
     * @param dynamic
     * @param current_page
     */
    defaultPaginateInit = (execute = null, dynamic = false, current_page = null) => {
        const
            {current_name} = this.props,
            stagePaginate = this.main.$stagePaginate({current_name: current_name, current_page: current_page});

        this.main.$current_name = current_name;

        this.gotoAndStopFrame(this.get(), frame);

        this.pageIn();

        stagePaginate.initPaginate(dynamic);

        this.$helpersIcon.setIcon(this.get(), button.color_icon);

        this.$helpersIcon.setIcon(this.getFrame(), button.color_icon);

        (typeof (execute) === 'function') && execute(stagePaginate);

        /**
         * Preloader
         */
        this.main.emit('process_end', {}, current_name);
    };

    /**
     * Single page.
     * Included helpersIcon color.
     */
    initCover = this.defaultInit;

    /**
     * Single page.
     * Included helpersIcon color.
     * For all pages simple.
     */
    initRecord = this.defaultInit;

    /**
     * Paginate.
     * Included helpersIcon color.
     * For all pages simple.
     */
    initPaginate = this.defaultPaginateInit;

    /**
     * Single page.
     * Included stageGallery and helpersIcon color.
     */
    initGallery = () => {
        this.defaultInit(() => {
            this.main.$stageGallery({current_name: this.props.current_name, xml: this.getObject(this.getCurrentIndex(), 'xml')}).mainGallery();
        });
    };

    /**
     * Paginate.
     * Included stageGallery and helpersIcon color.
     * @param current_page
     */
    initGalleryPaginate = (current_page) => {
        this.defaultPaginateInit(() => {
            const
                {current_name} = this.props,
                paginates = this.getObject(this.getCurrentIndex(), 'paginates'),
                defaultPaginate = this.getDefaultIndex(paginates),
                paginate = this.getCurrentIndex(paginates) || defaultPaginate,
                stageGallery = this.main.$stageGallery({current_name: current_name});

            if (this.inArray([2, 3], paginate.frame)) {
                stageGallery.props.xml = (this.getObject(paginate, 'xml') || gallery.xml);
                stageGallery.initGallery();

                const anim_container = document.getElementById('animation_container');

                this.main.$element_img = document.createElement('IMG');

                this.setAttributes(this.main.$element_img, {
                    id: 'close_overlay_container',
                    alt: 'close',
                    src: this.getUriImage('close.png'),
                    width: this.calcSize(1, stage.scaleX, 40, false, 'int'),
                    height: this.calcSize(1, stage.scaleY, 40, false, 'int')
                });

                const close = () => {
                    let
                        name = this.getObject(defaultPaginate, 'name'),
                        frame = this.getObject(defaultPaginate, 'frame'),
                        occ = this.padWithLeadingZeros(frame, 2);

                    this.pageOut();

                    this.main.$current_name_sub = name;
                    this.main.$current_frame_sub = occ;

                    this.main.$element_img.remove();
                };

                this.removeListener('click', 'click-close-overlay-container', () => {
                    this.addListener(this.main.$element_img, 'click', 'click-close-overlay-container', close);
                });

                anim_container.appendChild(this.main.$element_img);
            }
        });
    };

    /**
     * Single page.
     * Included stagePin and helpersIcon color.
     */
    initImplantation = () => {
        this.defaultInit(() => {
            this.main.$stagePin({current_name: this.props.current_name}).mainPin();
        });
    };

    /**
     * Paginate.
     * Included helpersIcon color.
     */
    initImplantationPaginate = () => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {current_name} = this.props,
                paginates = this.getObject(this.getCurrentIndex(), 'paginates'),
                stagePin = this.main.$stagePin({current_name: current_name}),
                paginate = this.getCurrentIndex(paginates) || this.getDefaultIndex(paginates);

            stagePin.props.xml = this.verifyField(paginate, 'xml');
            stagePin.props.content_text = this.verifyField(paginate, 'content_text');

            stagePin.mainPin();

            for (let property of paginates) {
                this.$helpersIcon.setIcon(_this_current, button.color_icon, property.frame);
            }

            this.$helpersIcon.disabledAnimate(_this_current)(paginate.frame);
        });
    };

    /**
     * Paginate.
     * Included stagePaginate, layerDifferential, layerCamera, layerPin and helpersIcon color.
     */
    initPlantPaginate = () => {
        this.defaultPaginateInit((stagePaginate) => {
            const
                _this_current = this.get(),
                {current_name} = this.props,
                paginates = this.getObject(this.getCurrentIndex(), 'paginates'),
                paginate = this.getCurrentIndex(paginates) || this.getDefaultIndex(paginates),
                active_differential = this.verifyField(paginate, 'active.differential'),
                active_differential_enabled = this.verifyField(paginate, 'active.differential_enabled'),
                active_camera = this.verifyField(paginate, 'active.camera'),
                active_pin = this.verifyField(paginate, 'active.pin');

            if (active_differential) {
                const layerDifferential = this.main.$layerDifferential({
                    current_name: current_name,
                    enabled: active_differential_enabled
                });

                layerDifferential.initDifferential();
                stagePaginate.setState({...stagePaginate.state, differential: layerDifferential});
            }

            if (active_camera) {
                const layerCamera = this.main.$layerCamera({current_name: current_name});

                layerCamera.initCamera();
                stagePaginate.setState({...stagePaginate.state, camera: layerCamera});
            }

            if (active_pin) {
                const layerPin = this.main.$layerPin({current_name: current_name});
                layerPin.initPin();
                stagePaginate.setState({...stagePaginate.state, pin: layerPin});
            }

            for (let property of paginates) {
                this.$helpersIcon.setIcon(_this_current, button.color_icon, property.frame);
            }

            this.$helpersIcon.disabledAnimate(_this_current)(paginate.frame);
        });
    };

    initLocalizationPaginate = () => {
        this.defaultPaginateInit(() => {
            const
                {current_name} = this.props,
                paginates = this.getObject(this.getCurrentIndex(), 'paginates'),
                paginate = this.getCurrentIndex(paginates) || this.getDefaultIndex(paginates);

            if (paginate.frame === 1) {
                const stageLocalization = this.main.$stageLocalization({current_name: current_name});

                stageLocalization.props.xml = this.verifyField(paginate, 'xml');

                stageLocalization.initLocalization();
            } else if (paginate.frame === 2) {
                const
                    _this_current = this.get(),
                    buttons = this.verifyField(_this_current, 'occ_frame_01.occ_marker.occ_buttons.children'),
                    markers = this.verifyField(_this_current, 'occ_frame_01.occ_marker.occ_markers');

                let current_btn, current_marker;

                const showMarker = function (event) {
                    const {button, marker} = this;

                    if (current_btn === button) {
                        current_btn.gotoAndPlay('off');
                        current_marker.gotoAndPlay('off');
                        current_btn = '';
                        current_marker = '';

                        return;
                    } else if (current_btn) {
                        current_btn.gotoAndPlay('off');
                        current_marker.gotoAndPlay('off');
                    }

                    current_btn = button;
                    current_marker = marker;
                    button.gotoAndPlay('on');
                    marker.gotoAndPlay('on');
                }

                buttons.forEach((button) => {
                    const
                        btn_number = parseInt(button.name.split('_')[1]),
                        number = (btn_number < 10) ? `0${btn_number}` : btn_number,
                        marker = markers[`occ_marker_${number}`];

                    button.gotoAndPlay('off');
                    marker.gotoAndPlay('off');
                    button.btn.removeEventListener('click', showMarker);
                    button.btn.addEventListener('click', showMarker.bind({button, marker}));
                });
            } else if (paginate.frame === 3) {
                this.main.$stageSlider({current_name: current_name, composition_name: paginate.name}).initSlider();
            }
        });
    };

    initProjectPaginate = () => {
        this.defaultPaginateInit((stagePaginate) => {
            const
                _this_current = this.get(),
                {current_name} = this.props,
                paginates = this.getObject(this.getCurrentIndex(), 'paginates'),
                paginate = this.getCurrentIndex(paginates) || this.getDefaultIndex(paginates);

            if (paginate.frame === 1) {
                const _this_frame = this.getFrame();

                _this_frame.occ_sector.gotoAndPlay('sector01');

                let children = this.verifyField(_this_frame, 'occ_button.children');

                if (this.isArrayIf(children)) {
                    for (let property of children) {
                        this.setHandleMouseDown(property, () => {
                            _this_frame.occ_sector.gotoAndPlay(`sector${this.padWithLeadingZeros(this.toNumber(property.name), 2)}`);
                        });
                    }
                }
            } else if (this.inArray([2, 6], paginate.frame)) {
                const stagePin = this.main.$stagePin({current_name: current_name});

                stagePin.props.xml = this.verifyField(paginate, 'xml');
                stagePin.props.content_text = this.verifyField(paginate, 'content_text');

                stagePin.initPin();
            } else if (this.inArray([3, 7, 8, 9], paginate.frame)) {
                for (let property of paginates) {
                    this.$helpersIcon.setIcon(_this_current, (paginate.frame === property.frame ? '0xFFFFFF' : button.color_icon), property.frame);
                }

                this.$helpersIcon.disabledAnimate(_this_current)(paginate.frame);
            }
        });
    };

    initRationalPaginate = () => {
        this.defaultPaginateInit();
        // this.defaultPaginateInit((stagePaginate) => {
        //     this.main.on('dynamic_paginate', ({number_current, current_name}) => {
        //         if(current_name === this.props.current_name){
        //             if (number_current === 2) {
        //                 const _this_frame = this.getFrame();
        //
        //                 let children = this.verifyField(_this_frame, 'occ_card.occ_button.children');
        //
        //                 if (this.isArrayIf(children)) {
        //                     for (let property of children) {
        //                         this.setHandleMouseDown(property, () => {
        //                             _this_frame.occ_card.gotoAndStop(`card${this.padWithLeadingZeros(this.toNumber(property.name), 2)}`);
        //                         });
        //                     }
        //                 }
        //             }
        //         }
        //     }, this.props.current_name);
        // }, true);
    };

    initInstitutionalPaginate = () => {
        this.defaultPaginateInit((stagePaginate) => {


            const execute = (event, options) => {
                let occ_button = this.getObject(options, 'occ_button');
                this.openVideo(occ_button, options);
            };

            this.main.on('dynamic_paginate', ({number_current, current_name}) => {
                if (current_name === this.props.current_name) {
                    if (number_current === 2) {
                        this.main.$stageSlider({
                            current_name: this.props.current_name,
                            composition_name: this.props.current_name
                        }).initSlider();
                    } else if (number_current === 3) {
                        let {btn_video01} = this.getFrame();

                        this.setHandleMouseDown(btn_video01, execute, {
                            occ_button: btn_video01,
                            name: 'video-01',
                            uri: `${this.$base_uri}/public/media/vr-girl.mp4`
                        });
                    }
                }
            }, this.props.current_name);

        }, true);
    };

    /**
     * Paginate.
     * Included stagePaginate, stageView and helpersIcon color.
     */
    initView = () => {
        this.defaultPaginateInit(() => {
            const {current_name} = this.props;
            this.main.$stageView({current_name: current_name}).initView();
        }, true);
    };

    /**
     * Single page.
     * Included stageSun and helpersIcon color.
     */
    initOrientation = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            this.main.$stageSun({current_name: current_name}).initSun();
        });
    };

    /**
     * Paginate.
     * Included helpersIcon color.
     */
    initOrientationPaginate = (current_page) => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {current_name} = this.props,
                paginates = this.getObject(this.getCurrentIndex(), 'paginates'),
                paginate = this.getCurrentIndex(paginates) || this.getDefaultIndex(paginates);

            this.main.$stageSun({current_name: current_name, current_page: current_page}).initSun();

            for (let property of paginates) {
                this.$helpersIcon.setIcon(_this_current, button.color_icon, property.frame);
            }

            this.$helpersIcon.disabledAnimate(_this_current)(paginate.frame);
        });
    };

    /**
     * Single page.
     * Included stageZoom and helpersIcon color.
     */
    initZoom = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            this.main.$stageZoom({current_name: current_name}).initZoom();
        });
    };

    /**
     * Single page.
     * Included stageSlider and helpersIcon color.
     */
    initSlider = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            this.main.$stageSlider({current_name: current_name, composition_name: current_name}).initSlider();
        });
    };

    /**
     * Single page.
     * Included stageScroll and helpersIcon color.
     */
    initScroll = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            this.main.$stageScroll({current_name: current_name}).initScroll();
        });
    };

    /**
     * Single page.
     * Included stageQuiz and helpersIcon color.
     */
    initQuiz = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            this.main.$stageQuiz({current_name: current_name}).initQuiz();
        });
    };

    /**
     * Single page.
     * Included stageMemory and helpersIcon color.
     */
    initMemory = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            this.main.$stageMemory({current_name: current_name}).initMemory();
        });
    };

    /**
     * Single page.
     * Included stageMarquee and helpersIcon color.
     */
    initMarquee = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            this.main.$stageMarquee({current_name: current_name}).initMarquee();
        });
    };

    /**
     * Single page.
     * Included stage360 and helpersIcon color.
     */
    init360 = () => {
        this.defaultInit(() => {
            const {current_name} = this.props;
            this.main.$stage360({current_name: current_name}).init360();
        });
    };

    /**
     * REVIEW
     */
    initVideo = () => {
        this.defaultInit(() => {
            const {
                btn_video01,
                btn_video02,
                btn_video03,
                btn_video04,
                btn_video05,
                btn_video06
            } = this.getFrame();

            const execute = (event, options) => {
                let occ_button = this.getObject(options, 'occ_button');
                this.openVideo(occ_button, options);
            };

            this.setHandleMouseDown(btn_video01, execute, {
                occ_button: btn_video01,
                name: 'video-01',
                uri: `${this.$base_uri}/public/media/doctor.mp4`
            });

            this.setHandleMouseDown(btn_video02, execute, {
                occ_button: btn_video02,
                name: 'video-02',
                uri: `${this.$base_uri}/public/media/example.mp4`
            });

            this.setHandleMouseDown(btn_video03, execute, {
                occ_button: btn_video03,
                name: 'video-03',
                uri: `${this.$base_uri}/public/media/vr-boy.mp4`
            });

            this.setHandleMouseDown(btn_video04, execute, {
                occ_button: btn_video04,
                name: 'video-04',
                uri: `${this.$base_uri}/public/media/vr-girl.mp4`
            });

            this.setHandleMouseDown(btn_video05, execute, {
                occ_button: btn_video05,
                name: 'video-05',
                uri: `${this.$base_uri}/public/media/doctor.mp4`
            });

            this.setHandleMouseDown(btn_video06, execute, {
                occ_button: btn_video06,
                name: 'video-06',
                uri: `${this.$base_uri}/public/media/example.mp4`
            });
        });
    };

    /**
     * REVIEW
     */
    initTour = () => {
        this.defaultInit(() => {
            const {
                btn_video01,
                btn_video02
            } = this.getFrame();

            const execute = (event, options) => {
                let occ_button = this.getObject(options, 'occ_button');
                this.openTour(occ_button, options);
            };

            this.setHandleMouseDown(btn_video01, execute, {
                occ_button: btn_video01,
                name: 'video-01',
                uri: 'https://dlightvr.com.br/fibra/florida/36_studio'
            });

            this.setHandleMouseDown(btn_video02, execute, {
                occ_button: btn_video02,
                name: 'video-02',
                uri: 'https://dlightvr.com.br/fibra/florida/33_apto/'
            });
        });
    };

    /**
     * REVIEW
     * @param current_page
     */
    initImplantationAndOrientation = (current_page) => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                {current_name} = this.props,
                paginates = this.getObject(this.getCurrentIndex(), 'paginates'),
                paginate = this.getCurrentIndex(paginates) || this.getDefaultIndex(paginates);

            if (current_page === 'implantacao') {
                const
                    stagePin = this.main.$stagePin({current_name: current_name}),
                    object = this.getCurrentIndex(),
                    paginates = this.getObject(object, 'paginates'),
                    paginate = this.getCurrentIndex(paginates) || this.getDefaultIndex(paginates);

                stagePin.props.xml = this.verifyField(paginate, 'xml');
                stagePin.props.content_text = this.verifyField(paginate, 'content_text');

                this.destroyTicker('_handleZoom');

                stagePin.initPin();
            } else if (current_page === 'orientacao') {
                const stageSun = this.main.$stageSun({current_name: current_name, current_page: current_page});

                this.destroyTicker('_handleZoom');

                stageSun.initSun();
            } else if (current_page === 'planta') {
                const stageZoom = this.main.$stageZoom({current_name: current_name});

                stageZoom.initZoom();
            }

            for (let property of paginates) {
                this.$helpersIcon.setIcon(_this_current, button.color_icon, property.frame);
            }

            this.$helpersIcon.disabledAnimate(_this_current)(paginate.frame);
        });
    };

    /**
     * REVIEW
     * Paginate.
     * Included stagePaginate and helpersIcon color.
     */
    initSlide = () => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                occ_pseudo_frame = this.verifyField(_this_current, 'occ_pseudo_frame01'),
                btn_frame = this.verifyField(_this_current, 'btn_frame01');

            this.$helpersIcon.disabledAnimate(_this_current)(1, 'frame');

            this.$helpersIcon.setIcon(_this_current, button.color_icon, 1);

            this.$helpersIcon.setIcon(_this_current, button.color_icon, 2);

            this.$helpersIcon.setIcon(_this_current, button.color_icon, 3);

            occ_pseudo_frame && (occ_pseudo_frame.visible = true);

            btn_frame && (btn_frame.visible = false);
        }, true);
    };

    /**
     * REVIEW
     * Single page.
     * Included helpersIcon color.
     */
    initProject = () => {
        this.defaultInit(() => {
            const {occ_project: {occ_project_01, occ_project_02, occ_project_03}} = this.getFrame();

            this.setHandleMouseDown(occ_project_01.btn_more, () => {
                (occ_project_02.currentLabel === 'complete') && occ_project_02.gotoAndPlay('complete');
                (occ_project_03.currentLabel === 'complete') && occ_project_03.gotoAndPlay('complete');

                occ_project_01.gotoAndPlay('start');
            }, null, `${occ_project_01.name}_more`);

            this.setHandleMouseDown(occ_project_01.btn_less, () => {
                occ_project_01.gotoAndPlay('complete');
            }, null, `${occ_project_01.name}_less`);

            this.$helpersIcon.setIcon(occ_project_01, button.color_icon);
            this.$helpersIcon.setIcon(occ_project_01.btn_more, button.color_icon);

            this.setHandleMouseDown(occ_project_02.btn_more, () => {
                (occ_project_01.currentLabel === 'complete') && occ_project_01.gotoAndPlay('complete');
                (occ_project_03.currentLabel === 'complete') && occ_project_03.gotoAndPlay('complete');

                occ_project_02.gotoAndPlay('start');
            }, null, `${occ_project_02.name}_more`);

            this.setHandleMouseDown(occ_project_02.btn_less, () => {
                occ_project_02.gotoAndPlay('complete');
            }, null, `${occ_project_02.name}_less`);

            this.$helpersIcon.setIcon(occ_project_02, button.color_icon);
            this.$helpersIcon.setIcon(occ_project_02.btn_more, button.color_icon);

            this.setHandleMouseDown(occ_project_03.btn_more, () => {
                (occ_project_01.currentLabel === 'complete') && occ_project_01.gotoAndPlay('complete');
                (occ_project_02.currentLabel === 'complete') && occ_project_02.gotoAndPlay('complete');

                occ_project_03.gotoAndPlay('start');
            }, null, `${occ_project_03.name}_more`);

            this.setHandleMouseDown(occ_project_03.btn_less, () => {
                occ_project_03.gotoAndPlay('complete');
            }, null, `${occ_project_03.name}_less`);

            this.$helpersIcon.setIcon(occ_project_03, button.color_icon);
            this.$helpersIcon.setIcon(occ_project_03.btn_more, button.color_icon);
        });
    };

    initSector = () => {
        this.defaultInit(() => {
            const {occ_line, btn_01, btn_02, btn_03, btn_04, btn_06} = this.getFrame();

            this.setHandleMouseDown(btn_01, () => {
                this.gotoAndStopFrame(occ_line, 1);
                occ_line.occ_01.gotoAndPlay('start');
            });

            this.setHandleMouseDown(btn_02, () => {
                this.gotoAndStopFrame(occ_line, 2);
                occ_line.occ_02.gotoAndPlay('start');
            });

            this.setHandleMouseDown(btn_03, () => {
                this.gotoAndStopFrame(occ_line, 3);
                occ_line.occ_03.gotoAndPlay('start');
            });

            this.setHandleMouseDown(btn_04, () => {
                this.gotoAndStopFrame(occ_line, 4);
                occ_line.occ_04.gotoAndPlay('start');
            });

            this.setHandleMouseDown(btn_06, () => {
                this.gotoAndStopFrame(occ_line, 6);
                occ_line.occ_06.gotoAndPlay('start');
            });
        });
    };

    initExternal = () => {
        this.defaultPaginateInit(() => {
            const
                _this_current = this.get(),
                occ_pseudo_frame = this.verifyField(_this_current, 'occ_pseudo_frame01'),
                btn_frame = this.verifyField(_this_current, 'btn_frame01'),
                children = this.verifyField(_this_current, 'occ_frame_03.occ_external.children');

            this.$helpersIcon.disabledAnimate(_this_current)(1, 'frame');

            this.$helpersIcon.setIcon(_this_current, button.color_icon, 1);

            this.$helpersIcon.setIcon(_this_current, button.color_icon, 2);

            this.$helpersIcon.setIcon(_this_current, button.color_icon, 3);

            occ_pseudo_frame && (occ_pseudo_frame.visible = true);

            btn_frame && (btn_frame.visible = false);

            let external = {
                '01': {
                    name: 'ALLTAP',
                    uri: 'https://www.alltap.com.br'
                },
                '02': {
                    name: 'ANIMATE CSS',
                    uri: 'https://animate.style/'
                },
                '03': {
                    name: 'BOOTSTRAP 5',
                    uri: 'https://getbootstrap.com/docs/5.0/getting-started/introduction'
                },
                '04': {
                    name: 'REACT JS',
                    uri: 'https://pt-br.legacy.reactjs.org'
                },
                '05': {
                    name: 'A-FRAME',
                    uri: 'https://aframe.io'
                },
                '06': {
                    name: 'CREATEJS',
                    uri: 'https://createjs.com'
                },
                '07': {
                    name: 'ADOBE ANIMATE',
                    uri: 'https://www.adobe.com/br/products/animate.html'
                }
            }

            if (this.isArrayIf(children)) {
                for (let property of children) {
                    let
                        name = property.name,
                        number = this.toNumber(name),
                        occ = this.padWithLeadingZeros(number, 2);

                    this.openExternal(property, external[occ]);
                }
            }
        }, true);
    };
}

/**
 *
 * @type {{}}
 */
PageCurrent.propTypes = {
    current_name: PropTypes.string
};

/**
 *
 * @type {{}}
 */
PageCurrent.defaultProps = {
    current_name: null
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(PageCurrent, {className: 'PageCurrent'});
